/**
 * MSK Assessment Reducers
 */
 import {
    MSKASSESSMENT_ACTION, 
    ALL_MSKASSESSMENT,
    CHECK_MSKASSESSMENT,
    CHECK_MSKASSESSMENT_DONE,
    CHECK_MSKASSESSMENT_FAILURE,
    ADD_MSKASSESSMENT,
    ADD_MSKASSESSMENT_SUCCESS,
    ADD_MSKASSESSMENT_FAILURE,
    FETCH_MSKASSESSMENT,
    EDIT_MSKASSESSMENT,
    EDIT_MSKASSESSMENT_SUCCESS,
    EDIT_MSKASSESSMENT_FAILURE,
    DELETE_MSKASSESSMENT_SUCCESS,
    DELETE_MSKASSESSMENT_FAILURE,
    ALL_POSTURE_HEAD,
    ALL_POSTURE_SHOULDERS,
    ALL_POSTURE_THORACIC,
    ALL_POSTURE_LUMBAR,
    ALL_POSTURE_PELVIS,
    ALL_POSTURE_KNEE,
    ALL_POSTURE_FEET,
    ALL_POSTURE_GLENOHUMERAL,
    ALL_POSTURE_ABBREIVATION,
    REPORT_MSKASSESSMENT,
    REPORT_MSKDATES
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    assessmentlists:[],
    loading: false,
    mskresponse:[],
    actionstatus:'',
    posturehead:[],
    postureshoulders:[],
    posturethoracic:[],
    posturelumbar:[],
    posturepelvis:[],
    postureknee:[],
    posturefeet:[],
    postureglenohumeral:[],
    postureabbreivation:[],
    reportmskresponse:[],
    reportDates:[],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case MSKASSESSMENT_ACTION:
            return { ...state, loading: true };

        case ALL_MSKASSESSMENT:
            return { ...state, loading: false, assessmentlists: action.payload };
        
        case CHECK_MSKASSESSMENT:
            return { ...state, loading: false, actionstatus:0 }; 

        case CHECK_MSKASSESSMENT_DONE:
            return { ...state, loading: false, actionstatus:1};   

        case CHECK_MSKASSESSMENT_FAILURE:
            return { ...state, loading: false, actionstatus:2 };        

        case ADD_MSKASSESSMENT:
            return { ...state, loading: false, actionstatus:0 }; 
        
        case ADD_MSKASSESSMENT_SUCCESS:
            return { ...state, loading: false, actionstatus:1 };   
            
        case ADD_MSKASSESSMENT_FAILURE:
            return { ...state, loading: false, actionstatus:2 };     
        
        case FETCH_MSKASSESSMENT:
            return { ...state, loading: false, mskresponse:action.payload };         
            
        case EDIT_MSKASSESSMENT:
            return { ...state, loading: false, actionstatus:0 }; 
        
        case EDIT_MSKASSESSMENT_SUCCESS:
            return { ...state, loading: false, actionstatus:1 };   
            
        case EDIT_MSKASSESSMENT_FAILURE:
            return { ...state, loading: false, actionstatus:2 };
        
        case DELETE_MSKASSESSMENT_SUCCESS:
            return { ...state, loading: false, actionstatus:1 };   
            
        case DELETE_MSKASSESSMENT_FAILURE:
            return { ...state, loading: false, actionstatus:2 };    
        
        case ALL_POSTURE_HEAD:
            return { ...state, loading: false, posturehead:action.payload };  
        
        case ALL_POSTURE_SHOULDERS:
            return { ...state, loading: false, postureshoulders:action.payload };      
        
        case ALL_POSTURE_THORACIC:
            return { ...state, loading: false, posturethoracic:action.payload };    
            
        case ALL_POSTURE_LUMBAR:
            return { ...state, loading: false, posturelumbar:action.payload };  

        case ALL_POSTURE_PELVIS:
            return { ...state, loading: false, posturepelvis:action.payload };  
        
        case ALL_POSTURE_KNEE:
            return { ...state, loading: false, postureknee:action.payload };  

        case ALL_POSTURE_FEET:
            return { ...state, loading: false, posturefeet:action.payload };     

        case ALL_POSTURE_GLENOHUMERAL:
            return { ...state, loading: false, postureglenohumeral:action.payload };     
       
        case ALL_POSTURE_ABBREIVATION:
            return { ...state, loading: false, postureabbreivation:action.payload };     

        case REPORT_MSKASSESSMENT:
            return { ...state, loading: false, reportmskresponse:action.payload };
            
        case REPORT_MSKDATES:
            return { ...state, loading: false, reportDates:action.payload };    

        default: return { ...state };
    }
}